import { render } from "./ActiveNoteMd.vue?vue&type=template&id=483f89f8"
import script from "./ActiveNoteMd.vue?vue&type=script&lang=js"
export * from "./ActiveNoteMd.vue?vue&type=script&lang=js"
script.render = render

export default script